import { fileUploadBaseModel } from './crud';

export * from './types';

export const useFileUploadsById = fileUploadBaseModel.fetchById();
export const useFileUploadsByIds = fileUploadBaseModel.fetchByIds();
export const useFileUploadsMany = fileUploadBaseModel.fetchMany();
export const useFileUploadsCount = fileUploadBaseModel.count();
export const useFileUploadsManyInfiniteQuery =
  fileUploadBaseModel.fetchPaginated();
export const useFileUploadsUpdateOne = fileUploadBaseModel.edit();
export const useFileUploadsCreateOne = fileUploadBaseModel.create();
export const useFileUploadsRemoveOne = fileUploadBaseModel.delete();
export const useFileUploadsRemoveByIds = fileUploadBaseModel.deleteByIds();

export const useFileUploadsByIdV2 = fileUploadBaseModel.fetchByIdV2();
export const useFileUploadsByIdsV2 = fileUploadBaseModel.fetchByIdsV2();
export const useFileUploadsManyV2 = fileUploadBaseModel.fetchManyV2();
export const useFileUploadsCountV2 = fileUploadBaseModel.countV2();
export const useFileUploadsManyInfiniteQueryV2 =
  fileUploadBaseModel.fetchPaginatedV2();
export const useFileUploadsUpdateOneV2 = fileUploadBaseModel.editV2();
export const useFileUploadsCreateOneV2 = fileUploadBaseModel.createV2();
export const useFileUploadsRemoveOneV2 = fileUploadBaseModel.deleteV2();
export const useFileUploadsRemoveByIdsV2 = fileUploadBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useFileUploadById = fileUploadBaseModel.fetchById();
export const useFileUploadByIds = fileUploadBaseModel.fetchByIds();
export const useFileUploadMany = fileUploadBaseModel.fetchMany();
export const useFileUploadCount = fileUploadBaseModel.count();
export const useFileUploadPagination = fileUploadBaseModel.fetchPaginated();
export const useFileUploadUpdateOne = fileUploadBaseModel.edit();
export const useFileUploadCreateOne = fileUploadBaseModel.create();
export const useFileUploadRemoveOne = fileUploadBaseModel.delete();
export const useFileUploadRemoveByIds = fileUploadBaseModel.deleteByIds();

export const useFileUploadByIdV2 = fileUploadBaseModel.fetchByIdV2();
export const useFileUploadByIdsV2 = fileUploadBaseModel.fetchByIdsV2();
export const useFileUploadManyV2 = fileUploadBaseModel.fetchManyV2();
export const useFileUploadCountV2 = fileUploadBaseModel.countV2();
export const useFileUploadPaginationV2 = fileUploadBaseModel.fetchPaginatedV2();
export const useFileUploadUpdateOneV2 = fileUploadBaseModel.editV2();
export const useFileUploadCreateOneV2 = fileUploadBaseModel.createV2();
export const useFileUploadRemoveOneV2 = fileUploadBaseModel.deleteV2();
export const useFileUploadRemoveByIdsV2 = fileUploadBaseModel.deleteByIdsV2();
